// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { reviewBudgetStyles } from "@insite/content-library/Widgets/Budget/ReviewBudget";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

reviewBudgetStyles.titleText = {
    as: "h4",
    variant: "h4",
};

reviewBudgetStyles.filterWrapper = {
    css: css`
        margin: 20px 0 24px 0;
    `,
};

reviewBudgetStyles.wrapper = {
    css: css`
        display: inline-block;
        margin: 0 22px 0 0;
        ${xScreen("lte", "xs")} {
            width: 100%;
            margin-bottom: 5px;
        }
    `,
};

reviewBudgetStyles.select = {
    css: css`
        min-width: 204px;
    `,
};
